// extracted by mini-css-extract-plugin
export default {"AccountMenuItem":"AccountMenuItem-styles__AccountMenuItem__JqpBc","AccountMenuItem__link":"AccountMenuItem-styles__AccountMenuItem__link__meISs"};